import { render, staticRenderFns } from "./ShiftPatterns.vue?vue&type=template&id=63bdc16a&scoped=true&"
import script from "./ShiftPatterns.vue?vue&type=script&lang=js&"
export * from "./ShiftPatterns.vue?vue&type=script&lang=js&"
import style0 from "./ShiftPatterns.vue?vue&type=style&index=0&id=63bdc16a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bdc16a",
  null
  
)

export default component.exports